export var MARQUEE_CSRF_HEADER_NAME = 'X-MARQUEE-CSRF-TOKEN';
export var MARQUEE_CSRF_COOKIE_NAME = 'MARQUEE-CSRF-TOKEN';